import React from "react";
import styled from "styled-components";
import Marquee from "react-fast-marquee";

// import Fade from 'react-reveal/Fade';

const ProgressBar = () => {
  const mySkills = [
    {
      title: "HTML & CSS",
      percentage: "90%",
      img:"images/1.png"
    },
    
    {
      title: "JAVASCRIPT",
      img:"images/2.png"
      
    },
    {
      title: "TAILWIND CSS",
      img:"images/4.png"
    },
    {
      title: "REACT JS",
      img:"images/3.png"
    },
    
    {
      title: "NODE JS",
      img:"images/5.png"
    },
    {
      title: "EXPRESS JS",
      img:"images/6.png"
    },
    {
      title: "GIT & GITHUB",
      img:"images/7.png"
    },
   
    
   
    
   
  ];

  const Skills = styled.section`
    .skill-set {
      margin-top:30px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-item: center;
      ${'' /* background-color:green; */}
    }
    .skill-bar {
        ${'' /* background-color: red; */}
        ${'' /* width:60vw; */}
      display: flex;
      justify-content: center;
      align-item: center;
      flex-wrap:wrap;
    }
    .skill {
     ${'' /* background-color: blue; */}
      display:flex;
      padding:1.5rem;
      flex-direction: column;
      justify-content: center;
      align-item: center;
    }
    .bar {
      background-color:${({ theme }) => theme.color.dgBack};
      width: 200px;
      height:100px;
      border-radius:10px;
    }
    .img{
    height: 100%;
    width: 100%;
    border-radius: 10px;

    }
    @media only screen and (max-width: 767px) {

      .about-h3{
        font-size:10px;
      }
      .bar {
      width: 110px;
      height:70px;
      border-radius: 15px;
    }

    .skill{
      padding:1.3rem;
    }
    }

  `;
  return (
    <Skills>
      
        <div className="skill-set">
          <h3 style={{textAlign:"center"}} className="name">MY SKILLS</h3>

          <Marquee >
          <div className="skill-bar">
          

         
            {mySkills.map((item, i) => (
              <>
             
              <div className="skill">
                <h3 className="about-h3">{item.title}</h3>
                <div className="bar">
                  <img className="img" src={item.img} alt="" />
                </div>
              </div>
              
              </>
              ))}
             
          </div>
          </Marquee>
        </div>
    </Skills>
  );
};

export default ProgressBar;
